import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const _S3_PREFIX = "https://media.werz.at/community-assets/DEBASER/"

const DEBASER: CommunityData = {
  code: "debaserklubben",
  inviteCode: "debaserklubben",
  name: "Debaser Klubben",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/debaserklubben`,
  socials: {},
  styles: {
    global: {
      counterColor: "#f0eee9",
      logo: {
        src: "https://media.werz.at/community-assets/DEBASER/web-logo.png",
        styles: "w-[128px] h-[132px]",
      },
      alternativeLogo: {
        src: "https://media.werz.at/community-assets/DEBASER/web-alternative-logo.png",
        styles: "w-[128px] h-[132px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#3c282a",
      asideBg: "#f28bab",
      asideStyles: "bg-[#f28bab]",
      contentBg: "",
      contentBoxShadow: "",
      bgDesktop: "https://media.werz.at/community-assets/DEBASER/web-background.jpg",
      bgMobile: "https://media.werz.at/community-assets/DEBASER/web-background-mobile.jpg",
      nonMemberBg: "https://media.werz.at/community-assets/DEBASER/web-background-non-member.jpg",
      mainFont: "font-['HossRoundRegular']",
      primaryButton:
        "bg-[#f0eee9] border border-[#f0eee9] rounded-lg px-6 py-4 !text-[#3c282a] font-['HossRoundRegular'] text-[16px] text-left",
    },
    navigation: {
      iconsColor: "#3c282a",
      sideBarSeparator: "",
      separator: "#f28bab33",
      item: "text-[#3c282a] font-['AntipolVFMedium'] text-[16px] uppercase text-center gap-x-[10px] -ml-2 text-opacity-50",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "bg-[#3c282a] rounded-[24px] !pb-8 overflow-hidden",
      titles:
        "text-[#f28bab] font-['AntipolVFMedium'] text-[30px] uppercase text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#f28bab] font-['HossRoundRegular'] text-[14px] text-left",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#f28bab]",
        sectionTitle:
          "text-[#f28bab] font-['AntipolVFMedium'] text-[30px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container: "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover  !rounded-[16px]",
          placeholderMedia: "w-full h-[256px] bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#f28bab] font-['AntipolVFMedium'] text-[20px] uppercase text-left leading-[110%]",
          subtitle: "text-[#f28bab] font-['HossRoundRegular'] text-[14px] text-left",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#f28bab]",
        sectionTitle:
          "text-[#f28bab] font-['AntipolVFMedium'] text-[30px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:!w-[228px] h-[183px] sm:!h-[128px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover rounded-[16px]",
          placeholderMedia: "w-full h-full bg-gray-400 rounded-[16px]",
          content: "flex flex-col px-0 sm:!px-4 py-4 sm:!py-0 bg-transparent p-4",
          title:
            "text-[#f28bab] font-['AntipolVFMedium'] text-[14px] uppercase text-left leading-[110%]",
          subtitle: "text-[#f28bab] font-['HossRoundRegular'] text-[12px] text-left",
          location: "text-[#f28bab] font-['HossRoundRegular'] text-[12px] text-left",
          date: "text-[#f28bab] font-['HossRoundRegular'] text-[12px] text-left",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#f28bab] font-['AntipolVFRegular'] text-[26px] uppercase text-left leading-[110%]",
        text: "text-[#f28bab] font-['HossRoundRegular'] text-[16px] text-left",
        customShopImageStyle: "border border-[#000000] rounded-[16px]",
        sectionTitle:
          "text-[#f28bab] font-['AntipolVFRegular'] text-[26px] uppercase text-left leading-[110%] !mb-4 sm:mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#3c282a] rounded-[24px] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4",
        media:
          "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 border border-[#000000] rounded-[16px]",
        title:
          "text-[#f28bab] font-['AntipolVFMedium'] text-[30px] uppercase text-left leading-[110%]",
        subtitle: "text-[#f28bab] font-['HossRoundRegular'] text-[14px] text-left mb-4",
        button:
          "bg-[#f0eee9] border border-[#f0eee9] rounded-lg px-6 py-4 !w-fit mb-4 sm:mb-0 text-[#3c282a] font-['HossRoundRegular'] text-[16px] text-left",
        questions: "text-[14px] text-left text-[#f28bab]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#f28bab] border-t",
        header:
          "text-[#f28bab] font-['AntipolVFRegular'] text-[26px] uppercase text-left leading-[110%]",
        text: "text-[#f28bab] font-['HossRoundRegular'] text-[14px] text-left mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#f28bab] border-t",
        header:
          "text-[#f28bab] font-['AntipolVFRegular'] text-[26px] uppercase text-left leading-[110%]",
        text: "text-[#f28bab] font-['HossRoundRegular'] text-[14px] text-left mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden border border-[#f28bab] gap-y-[10px] rounded-[16px]",
        mapPinColor: "#f0eee9",
        mapStrokeColor: "#6d6d6d",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#f28bab] font-['AntipolVFRegular'] text-[26px] uppercase text-left leading-[110%]",
        text: "text-[#f28bab] font-['HossRoundRegular'] text-[14px] text-left",
      },
      tickets: {
        header:
          "text-[#f28bab] font-['AntipolVFMedium'] text-[30px] uppercase text-left leading-[110%] border-t border-[#f28bab] px-4 sm:px-8 pt-4 sm:pt-8 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#3c282a] border border-[#f28bab] rounded-[24px] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#3c282a] border border-[#f0eee9] rounded-lg px-4 py-3 text-[#f0eee9] font-['HossRoundRegular'] text-[14px] text-left !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between gap-4 leading-auto !bg-[#ffffff00] border border-[#f28bab] py-4 mb-4 p-4",
          media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4",
          name: "text-[#f28bab] font-['AntipolVFMedium'] text-[14px] uppercase text-left leading-[110%]",
          description: "text-[#f28bab] font-['HossRoundRegular'] text-[14px] text-left",
          price:
            "text-[#f28bab] font-['AntipolVFMedium'] text-[14px] uppercase text-left leading-[110%]",
          quantity: "text-[#3c282a] font-['HossRoundRegular'] text-[14px] text-left",
          status:
            "text-[#f28bab] font-['AntipolVFMedium'] text-[14px] uppercase text-left leading-[110%]",
          counterContainer:
            "bg-[#f0eee9] border border-[#f0eee9] rounded-lg px-4 py-3 gap-x-4 !w-fit",
          button:
            "bg-[#3c282a] border border-[#f0eee9] rounded-lg px-4 py-3 text-[#f0eee9] font-['HossRoundRegular'] text-[14px] text-left !w-fit",
          plusMinusColor: "#3c282a",
        },
      },
    },
  },
}

export default DEBASER
